// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__vZwRo","p":"styles_p__100Qj","plano":"styles_plano__2MrGh","selects":"styles_selects__f9LSU","left":"styles_left__xt0cT","right":"styles_right___zEFI"};